import type { TipoAtributo } from "interfaces/loja";

export const TIPO_OPCOES: TipoAtributo[] = [
  "LISTA",
  "TEXTO",
  "NUMERO",
  "BOOLEANO",
  "COR",
];

export const TIPOS_COM_OPCOES: TipoAtributo[] = ["LISTA", "COR"];

export const TIPO_LABELS: Record<TipoAtributo, string> = {
  LISTA: "Lista",
  TEXTO: "Texto livre",
  NUMERO: "Número",
  BOOLEANO: "Sim/Não",
  COR: "Cor",
};

export const TIPO_DESCRICOES: Record<TipoAtributo, string> = {
  LISTA: "Opções fixas (ex.: tamanho P, M, G)",
  TEXTO: "Valor livre digitado pelo cliente",
  NUMERO: "Valor numérico",
  BOOLEANO: "Escolha sim ou não",
  COR: "Variações por cor com amostra visual",
};

export const TIPO_FILTER_OPTIONS: { value: TipoAtributo | ""; label: string }[] = [
  { value: "", label: "Todos" },
  ...TIPO_OPCOES.map((t) => ({ value: t, label: TIPO_LABELS[t] })),
];

export function permiteOpcoes(tipo: TipoAtributo): boolean {
  return TIPOS_COM_OPCOES.includes(tipo);
}

export function tipoChipSx(tipo: TipoAtributo) {
  const map: Record<TipoAtributo, { bg: string; fg: string }> = {
    LISTA: { bg: "rgba(249, 96, 48, 0.12)", fg: "#c2410c" },
    COR: { bg: "rgba(147, 51, 234, 0.12)", fg: "#7e22ce" },
    TEXTO: { bg: "rgba(59, 130, 246, 0.12)", fg: "#1d4ed8" },
    NUMERO: { bg: "rgba(16, 185, 129, 0.12)", fg: "#047857" },
    BOOLEANO: { bg: "rgba(107, 114, 128, 0.12)", fg: "#374151" },
  };
  return map[tipo];
}

export function isHexColor(valor: string): boolean {
  return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(valor.trim());
}
